import React from "react";
import cx from "classnames";
import { Dropdown } from "react-bootstrap";
import styles from "./sortByAction.module.scss";

interface SortState {
  sortBy: string;
  orderBy: string;
}

interface SortByActionProps {
  value: SortState;
  onChange: (value: SortState) => void;
  sortOptions: { label: string; value: string }[];
}

export const SortByAction: React.FC<SortByActionProps> = ({
  value,
  onChange,
  sortOptions,
}) => {
  const { sortBy, orderBy } = value;

  const sortByLabel = React.useMemo(
    () => sortOptions.find((o) => o.value === sortBy)?.label,
    [sortBy, sortOptions],
  );

  const toggleSortOrder = () => {
    onChange({ ...value, orderBy: orderBy === "ASC" ? "DESC" : "ASC" });
  };

  const handleSortByChange = (change: string) => {
    onChange({
      sortBy: change,
      orderBy:
        sortBy === change ? (orderBy === "ASC" ? "DESC" : "ASC") : orderBy,
    });
  };

  return (
    <div className={styles.container}>
      <Dropdown>
        <Dropdown.Toggle className={styles.button} as="button">
          <i className={cx(styles.icon, "paperflite-menu")} />
        </Dropdown.Toggle>
        <Dropdown.Menu
          className={styles.menu}
          popperConfig={{
            modifiers: [{ name: "offset", options: { offset: [0, 6] } }],
          }}
        >
          {sortOptions.map((item) => (
            <Dropdown.Item
              key={item.value}
              className={cx(styles.menuItem, {
                [styles.active]: item.label === sortByLabel,
              })}
              onClick={() => handleSortByChange(item.value)}
            >
              {item.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
      <div className={styles.details}>
        <div className={styles.title}>Sort by</div>
        <div className={styles.field}>
          {sortByLabel}
          <div
            className={cx(styles.indicator, styles[orderBy])}
            onClick={toggleSortOrder}
          >
            <i className={cx(styles.arrow, styles.up, "paperflite-dropdown")} />
            <i
              className={cx(styles.arrow, styles.down, "paperflite-dropdown")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
